import styles from './styles.module.scss'
import Text from '../Text'
import clsx from 'clsx'
import { useSelector, useDispatch } from 'react-redux'
import { sendSentCloseButtonAction } from 'app/redux/messages/messages.actions'
import OperatorAvatarWithName from 'app/components/TextMessage/components/OperatorAvatarWithName'

const getAcceptedChat = ({ messagesData }) => messagesData.acceptedChat
const getActiveDepartment = ({ messagesData }) => messagesData.activeDepartment.data

const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts

function SentCloseButton() {
  const acceptedChat = useSelector(getAcceptedChat)
  const activeDepartment = useSelector(getActiveDepartment)
  const acceptedChatInfo = acceptedChat[activeDepartment]
  const texts = useSelector(getTexts)
  const dispatch = useDispatch()
  if (!acceptedChatInfo?.meta?.letUserClose?.value) return null

  const handleActionClick = (value) => {
    dispatch(sendSentCloseButtonAction({ value }))
  }

  return (
    <div className={styles.sent_close_button}>
      <OperatorAvatarWithName
        operatorName={acceptedChatInfo?.meta?.letUserClose?.agentInfo?.name}
        operatorAvatar={acceptedChatInfo?.meta?.letUserClose?.agentInfo?.avatar}
      />

      <Text type="operator" title={texts.verify_user_close} textContent={texts.verify_user_close} />
      <div className={styles.sent_close_button__btn_container}>
        <button
          className={clsx(styles.sent_close_button__btn, styles.sent_close_button__btn__no)}
          onClick={() => handleActionClick(true)}
        >
          {texts.verify_user_close_no}
        </button>
        <button
          className={clsx(styles.sent_close_button__btn, styles.sent_close_button__btn__yes)}
          onClick={() => handleActionClick(false)}
        >
          {texts.verify_user_close_yes}
        </button>
      </div>
    </div>
  )
}

export default SentCloseButton